export const FOLLOWUP_REPORT_LOADING = 'FOLLOWUP_REPORT_LOADING'
export const GET_FOLLOW_UP_REPORT = 'GET_FOLLOW_UP_REPORT'
export const GET_FOLLOW_UP_REPORT_TOTAL = 'GET_FOLLOW_UP_REPORT_TOTAL'
export const CLEAR_FOLLOW_UP_REPORT = 'CLEAR_FOLLOW_UP_REPORT'
export const GET_FOLLOW_UP_PDF_DATA = 'GET_FOLLOW_UP_PDF_DATA'
